<template>
	<div>

		<el-card class="box-card">
			<div style="display: flex;background: white">
				<div style="width: 50%;text-align: left;display: flex">
					<el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
					<el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[686]')}}</el-button>
					<el-upload
							class="upload-demo"
							ref="upload"
							:action="uploadurl"
							:on-preview="handlePreview"
							:on-remove="handleRemove"
							:on-change="handleChange"
							:on-success="handleSuccess"
							:on-error="handleError"
							:file-list="fileList"
							:limit="1"
							accept=".xlsx"
							style="margin-left: 8px"
					>
						<el-button slot="trigger" size="mini" type="primary">{{$t('getapi[6507]')}}</el-button>
					</el-upload>
				</div>

				<div style="width: 50%;text-align: right">
					<el-button type="primary" size="mini" @click="check">{{$t('getapi[439]')}}</el-button>
					<el-button type="primary" size="mini" @click="save" :disabled="!ischeck">{{$t('getapi[370]')}}</el-button>
					<!--<el-button type="primary" size="mini">关闭</el-button>-->
				</div>
			</div>
		</el-card>
		<div id="xpane-0">
			<vxe-table
					:data="datajson"
					show-overflow
					ref='CloseSoTable'
					size="mini" :loading="loading"  :height="tableHeight" stripe border resizable>
				<vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="errormsg" :title="$t('getapi[357]')" width="150px">
				</vxe-table-column>
				<vxe-table-column show-footer-overflow field="invoice_code" :title="$t('getapi[3681]')" width="100" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="customer_code" :title="$t('getapi[2610]')" width="150px">
				</vxe-table-column>
				<vxe-table-column show-footer-overflow field="invoice_type_code" :title="$t('getapi[3682]')" width="100" ></vxe-table-column>
				<vxe-table-column show-footer-overflow field="order_type_code" :title="$t('getapi[1976]')" width="80px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="invoice_date" :title="$t('getapi[3683]')" width="150px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')" width="100px"></vxe-table-column>
                <vxe-table-column show-footer-overflow field="cust_part" :title="$t('getapi[2390]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="invoice_qty" :title="$t('getapi[2995]')" width="100px" align="right"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="customer_net_unit_price" :title="$t('getapi[1410]')" width="100px" align="right"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="customer_line_net_total_amount" :title="$t('getapi[2102]')" width="100px" align="right"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="issue_order_no" :title="$t('getapi[2292]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="issue_order_line_no" :title="$t('getapi[2869]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="sal_code" :title="$t('getapi[2291]')" width="100px"></vxe-table-column>
				<vxe-table-column show-footer-overflow field="remark2" :title="$t('getapi[7963]')" width="100px"></vxe-table-column>
			</vxe-table>
		</div>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';
    export default {
        name:'3_saleinvoiceimp',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-160
            }
        },
        data() {
            return {
                fileList: [],
                itevisible:false,
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                loading: false, // 主表加载状态
                uploadurl: '',
				ischeck: false,
                scrollTop:0,
            };
        },
        created () {
            setTimeout(() => {
                this.datajson = [];
            }, 1000)
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Sal/RedInv/SalInvBatchImportToUpFile?token=' + token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
            },
            deleteAll(){
                let that = this;
                let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
                for(let i=selectRecords.length-1;i>=0;i--){
                    let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
                    that.datajson.splice(line, 1);
                }
            },
            download(){
                let param={
                    url:'/Sal/RedInv/SalInvBatchImportTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        if(file.response.DataContent.length>0){
                            that.datajson = file.response.DataContent;
                        }else{
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if(res.DataContent.length>0){
                        that.datajson = res.DataContent;
                        that.ischeck = false
                    }else{
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }

                }
                that.fileList=[];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
			//校验
            check() {
                let that = this
				let lan = that.$processdata.getLang()
				for(let i=0;i<that.datajson.length;i++){
                    that.datajson[i].LangType= lan
				}
                let parm = that.datajson
                that.$http.urlpost('/Sal/RedInv/SalCostOrderToImportCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent.dt
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.ischeck = true
                    } else {
                        that.datajson = res.DataContent.dt
                    }
                });
			},
            // 保存备注数据
            save() {
                let that = this;
                if(that.datajson.length==0){
                    that.$message.warning(that.$t('getapi[8712]'));//'请添加导入数据！'
                    return;
                }
                let parm = that.datajson
                that.$http.urlpost('/Sal/RedInv/SalCostOrderToImportSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson=[];
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    } else if(res.Success == 2){
                        that.datajson = res.DataContent.dt
                    }
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
	span.label-fade-enter {
		font-size: medium;
		margin-right: 20px;
	}
</style>
<style>
	.el-message-box {
		width: 600px;
	}
</style>
